import "../Page5/Page5.css"
import { motion } from 'framer-motion';
export default function Page5(){
    return <motion.div 
    initial={{
        y:-90,
        opacity:0
    }}
    whileInView={{
        y:0,
        opacity:1
    }}
    transition={{duration:0.7}}
    className="MainDivSocial" id="socialSection">
        <h1 style={{color:"white"}} className="Hedaing">Social Info</h1>
        <div
        className="socialDiv">
            <div style={{
                fontSize:"35px",
                fontWeight:"200",
                paddingTop:"20px",
            }}>
                Let's connect and <br/><span style={{
                fontSize:"20px",
                fontWeight:"200"
            }}>Talk about yout next big project</span>
            </div>
            <div>
            <div>
                <a style={{fontWeight:"100",textDecoration:"none",color:"black",display:"flex",alignItems:"center",justifyContent:"center"}} href="https://github.com/Infinite-Null" target="_blank" rel="noreferrer">
                    <h1 style={{fontWeight:"100"}}><i class="fa-brands fa-github"></i>&nbsp;Github</h1>
                </a>
            </div>
            <div>
                <a style={{fontWeight:"100",textDecoration:"none",color:"black",display:"flex",alignItems:"center",justifyContent:"center"}} href="https://www.linkedin.com/in/ankit-kumar-shah-147333247/" target="_blank" rel="noreferrer">
                    <h1 style={{fontWeight:"100"}}><i class="fa-brands fa-linkedin"></i>&nbsp;LinkedIn</h1>
                </a>
            </div>
            </div>
            <div>
            <div>
                <a style={{fontWeight:"100",textDecoration:"none",color:"black",display:"flex",alignItems:"center",justifyContent:"center"}} href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&to=ankit.kum.sha9933@gmail.com" target="_blank" rel="noreferrer">
                    <h1 style={{fontWeight:"100"}}><i class="fa-solid fa-envelope-open-text"></i>&nbsp;Gmail</h1>
                </a>
            </div>
            <div>
                <a style={{fontWeight:"100",textDecoration:"none",color:"black",display:"flex",alignItems:"center",justifyContent:"center"}} href="https://www.instagram.com/ankit_kumar.cpp/" target="_blank" rel="noreferrer">
                    <h1 style={{fontWeight:"100"}}><i class="fa-brands fa-instagram"></i>&nbsp;Instagram</h1>
                </a>
            </div>
            </div>
        </div>
    </motion.div>
}